import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=5516ecbc&"
import script from "./Department.vue?vue&type=script&lang=ts&"
export * from "./Department.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports